<template>
  <div>
    <div v-if="message" class="alert alert-warning alert-colors">
      <p>{{ message }}</p>
    </div>
    <div class="datagrid-wrapper">
      <div class="row">
        <div class="col-md-12">
          <form @submit.prevent="search(1)" class="row">
            <div class="header col-sm-12">
              <div class="grid-buttons" v-if="canCreateContractor">
                <a
                  class="btn btn-light"
                  :href="`/centre/${centre.id}/access/contractor/create`"
                  >
                    Add contractor access
                  </a>
              </div>
              <div>
                <div class="search-form-mask open">
                  <input type="text" class="sb-search-input" v-model="query" />
                  <button class="btn btn-light sb-icon-search">
                    <span class="fa fa-search">
                      <span class="visually-hidden">Search</span>
                    </span>
                  </button>
                </div>
              </div>
              <multiselect
                class="multiselect"
                v-model="selectedType"
                :options="['contractor', 'cleaner', 'security']"
                placeholder="Any Type"
                :searchable="true"
                @input="search(1)"
                :allow-empty="true"
              ></multiselect>
            </div>
          </form>
        </div>
        <div data-type="grid" class="col-md-12">
          <table class="datagrid table access-request-list">
            <thead>
              <tr>
                <th><h4>Name (Requested For)</h4></th>
                <th><h4>Contractor Type</h4></th>
                <th><h4>From</h4></th>
                <th><h4>Until</h4></th>
                <th><h4>Access Days</h4></th>
                <th><h4>Access Hours</h4></th>
                <th><h4>Tag</h4></th>
                <th><h4>Actions</h4></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!response?.data">
                <td colspan="8">
                  <span class="spinner anim-spin"></span>
                </td>
              </tr>
              <tr v-else-if="!response?.data?.length">
                <td colspan="8">No contractor access found</td>
              </tr>
              <tr v-for="access in response.data" v-bind:key="access.id">
                <td>
                  <a :href="`/employees/${access.user.id}`">
                    {{ access.user.full_name }}</a
                  >
                </td>
                <td>{{ access.user.type }}</td>
                <td>{{ $formatDate(access.from, user_date_format) }}</td>
                <td>{{ $formatDate( access.until, user_date_format) }}</td>
                <td>{{ access.days }}</td>
                <td>{{ access.access_hours }}</td>
                <td :class="{ 'text-inactive': !access.tag_number }">
                  {{ access.tag_number ? access.tag_number : "none" }}
                </td>
                <td>
                  <a
                    :href="`/centre/${centre.id}/access/${access.id}/contractor-edit`"
                    class="btn btn-link link-button"
                    >Edit</a
                  >
                  -
                  <form
                    class="inline"
                    @submit.prevent="deleteContractorAccess(access.id)"
                  >
                    <button class="btn btn-link link-button">delete</button>
                  </form>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3">
                  <div class="is-text-centered">
                    <full-pagination
                      :pagination="meta"
                      @paginate="search"
                    >
                    </full-pagination>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Access from "../Services/Access";
import Multiselect from "vue-multiselect";
import FullPagination from "./UI/FullPagination.vue";

export default {
  name: "ContractorAccessTableComponent",
  components: {
    Multiselect,
    FullPagination,
  },
  props: {
    centre: {
      type: Object,
      required: true,
    },
    contractorCountConfiguration: {
      type: Object,
      required: false
    },
    canCreateContractor: {
        type: Boolean,
        default: false,
    },
    user_date_format: {
      type: String,
    }
  },
  data: function () {
    return {
      response: {},
      meta: {},
      query: "",
      selectedType: null,
      message: null,
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search: function (page = 1) {
      Access.searchContractorAccess(
            this.centre.id,
            this.query,
            this.selectedType,
            page
      ).then((response) => {
        this.response = response;
        this.meta = response.meta;
      });
    },
    deleteContractorAccess: async function (accessId) {
      if (!confirm("Are you sure you want to delete this contractor access? This will unlink any linked tags and remove this contractor.")) {
        return;
      }
      this.message = await Access.deleteContractorAccess(
        this.centre.id,
        accessId
      );

      this.search(1)
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  width: auto;
}

.header > * + * {
  margin: 0 8px;
}

.sb-search-input {
  padding: 6px 12px;
}

.multiselect {
  max-width: 20rem;
}
</style>
